import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import Container from '@material-ui/core/Container';
import Toolbar from '@material-ui/core/Toolbar';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
// import { fade, makeStyles, withStyles } from '@material-ui/core/styles'; // Needed for Search
import { makeStyles, withStyles } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import hex2Rgba from './hex2Rgba'
import ReactGA from 'react-ga';
// import InputBase from '@material-ui/core/InputBase';
// import SearchIcon from '@material-ui/icons/Search';
import logo from '../images/logo_small.png'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  drawer: {
    width: 225
  },
  toolbar: {
    ...theme.mixins.toolbar,
    background: theme.palette.primary.main,
    color: theme.palette.getContrastText(theme.palette.primary.main),
    '& div': {
      marginLeft: 0,
      marginTop: theme.spacing(1),
      justifyContent: 'flex-start'
    },
    '& p': {
      marginLeft: theme.spacing(1)
    }
  },
  titleContainer: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
      marginLeft: theme.spacing(-4)
    }
  },
  logo: {
    marginRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1)
  },
  links: {
    paddingTop: '2px', //Fix medium size of buttom
    marginRight: theme.spacing(-1),
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  // search: {
  //   position: 'relative',
  //   borderRadius: theme.shape.borderRadius,
  //   backgroundColor: fade(theme.palette.common.white, 0.15),
  //   '&:hover': {
  //     backgroundColor: fade(theme.palette.common.white, 0.25),
  //   },
  //   marginLeft: 0,
  //   width: '100%',
  //   [theme.breakpoints.up('sm')]: {
  //     marginLeft: theme.spacing(1),
  //     width: 'auto',
  //   },
  // },
  // searchIcon: {
  //   padding: theme.spacing(0, 2),
  //   height: '100%',
  //   position: 'absolute',
  //   pointerEvents: 'none',
  //   display: 'flex',
  //   alignItems: 'center',
  //   justifyContent: 'center',
  // },
  // inputRoot: {
  //   color: 'inherit',
  // },
  // inputInput: {
  //   padding: theme.spacing(1, 1, 1, 0),
  //   // vertical padding + font size from searchIcon
  //   paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
  //   transition: theme.transitions.create('width'),
  //   width: '100%',
  //   [theme.breakpoints.up('sm')]: {
  //     width: '12ch',
  //     '&:focus': {
  //       width: '20ch',
  //     },
  //   },
  // },
}));

const ColorButtonGroup = withStyles((theme) => ({
  grouped: {
    '&:not(:last-child)': {
      borderRight: `1px solid ${hex2Rgba(theme.palette.getContrastText(theme.palette.primary.main), 0.4)}`,
    }
  },
}))(ButtonGroup);

const ColorButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(theme.palette.primary.main),
    marginRight: theme.spacing(1)
  },
}))(Button);

export default function Header({ links }) {
  const classes = useStyles();
  const [drawerState, setDrawerState] = React.useState(false)

  const toolbarButtons = links.map((item, index) =>
    <ColorButton
      key={index}
      component={RouterLink}
      startIcon={item.icon}
      to={item.path}
    >
      {item.name}
    </ColorButton>
  )

  const drawerListItems = links.map((item, index) =>
    <ListItem key={index} button component={RouterLink} to={item.path}>
      <ListItemIcon>
        {item.icon}
      </ListItemIcon>
      <ListItemText primary={item.name} />
    </ListItem>
  )

  return (
    <>
      <div className={classes.root}>
        <AppBar position="fixed">
          <Container maxWidth="lg">
            <Toolbar disableGutters={true}>
              <IconButton
                edge="start"
                className={classes.menuButton}
                color="inherit"
                aria-label="open drawer"
                onClick={(e) => {setDrawerState(true); 
                  ReactGA.event({
                    category: "Navigation",
                    action: 'Clicked Hamburger'
                })}}
              >
                <MenuIcon />
              </IconButton>
              <div className={classes.titleContainer}>
                <img className={classes.logo} src={logo} alt="Logo" height="40px" />
                <Typography className={classes.title} variant="h6" noWrap>
                  RQuaL Solutions
                </Typography>
              </div>
              <ColorButtonGroup variant="text" className={classes.links}>
                {toolbarButtons}
              </ColorButtonGroup>
              {/* <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <InputBase
              placeholder="Search…"
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              inputProps={{ 'aria-label': 'search' }}
            />
          </div> */}
            </Toolbar>
          </Container>
        </AppBar>
      </div>
      <Drawer
        anchor="left"
        open={drawerState}
        onClose={(e) => setDrawerState(false)}
      >
        <div className={classes.toolbar}>
          <div className={classes.titleContainer}>
            <img className={classes.logo} src={logo} alt="Logo" height="40px" />
            <Typography className={classes.title} variant="body1" noWrap>
              <b>RQuaL Solutions</b>
            </Typography>
          </div>
        </div>
        <Divider />
        <List
          component="nav"
          className={classes.drawer}
          onClick={(e) =>
            setDrawerState(false)}
        >
          {drawerListItems}
        </List>
      </Drawer>
    </>
  );
}
